import { useState } from 'react';
import  "../Css/ModalCalculator.css";
import { IonModal, IonContent, IonToolbar, IonButton, IonIcon, IonTitle, 
    IonButtons, IonCard, IonRow, IonCol, useIonToast} from "@ionic/react";
import styles from '../Css/Calculator.module.scss';
import { close, arrowBack, copy, checkmarkCircleOutline, closeCircle } from 'ionicons/icons';
import {evaluate} from 'mathjs';

const Calculator = ({ open, fnClose }) => {
    const [num, setNum] = useState('');
    const [result, setResult] = useState('');
    const [present] = useIonToast();
    const [beforeEqual, setBeforeEqual] = useState(false);
    const operators = ['/', '+', '*', '-'];

    const handleButtonClick = (value: string) => {
        if (value === '=') {
        try {
            let operation = num;
            if(operators.includes(num[num.length-1])){
                operation = num.slice(0, -1);
            }
            const calculation = evaluate(operation);
            setNum(operation);
            setResult('= '+calculation.toString());
            setBeforeEqual(true);
        } catch (error) {
            setResult('Error');
        }
        } else if (value === 'C') {
            setNum('');
            setResult('');
            setBeforeEqual(false);
        } else if (value === 'DEL') {
            setNum(num.slice(0, -1));
            setBeforeEqual(false);
        } else {
            if(num.length > 0){
                if(operators.includes(num[num.length-1]) && operators.includes(value)){
                    console.log(value);
                    if(beforeEqual){
                        setNum(result.slice(1)+value);
                    } else {
                        setNum(num.slice(0, -1)+value);
                    }
                } else {
                    if(operators.includes(value) && beforeEqual){
                        setNum(result.slice(1)+value);
                    } else {
                        setNum(num + value);
                    }
                }
            } else if(num.length === 0 && value !== '/' && value !==  '*'){
                setNum(num + value);
            } 
            setBeforeEqual(false);
        }
    };

    const copyResult = () => {
        if(result){
            navigator.clipboard.writeText(result.slice(1)).then(() => {
                present({
                    message: 'Resultado copiado exitosamente',
                    duration: 3000,
                    position: 'bottom',
                    color: 'success',
                    icon: checkmarkCircleOutline
                })
            }).catch(err => {
                console.error("Error al copiar el texto: ", err);
            });
        } else {
            present({
                message: 'El resultado no pudo ser copiado',
                duration: 3000,
                position: 'bottom',
                color: 'secondary',
                icon: closeCircle
            });
        }
    };

    return (
        <IonModal id="calculator-modal" isOpen={open} backdrop={true} onDidDismiss={() => fnClose(false)}>
            <IonContent>
                <IonToolbar className={styles.tittleCalculator}>
                    <IonTitle className={styles.tittle}>Calculadora</IonTitle>
                    <IonButtons slot="end">
                        <IonButton color="light" onClick={() => fnClose(false)}>
                            <IonIcon icon={close} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
                <div className={styles.centerContent}>
                <IonCard className={styles.contentCalculator}>
                    <IonRow >
                        <IonCol size="12" size-md="12" className={styles.centerContent}>
                            <div className={styles.calculatorScreen}>
                                <label className={styles.letterOperation}>{num}</label>
                                <label className={styles.letterResult}>{result}</label>
                            </div>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => handleButtonClick('C')}>
                                C
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => copyResult()}>
                                <IonIcon icon={copy}/>
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => handleButtonClick('DEL')}>
                                <IonIcon icon={arrowBack}/>
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => handleButtonClick('/')}>
                                /
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('7')}>
                                7
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('8')}>
                                8
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('9')}>
                                9
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => handleButtonClick('*')}>
                                <IonIcon icon={close}/>
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('4')}>
                                4
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('5')}>
                                5
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('6')}>
                                6
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => handleButtonClick('-')}>
                                -
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('1')}>
                                1
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('2')}>
                                2
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('3')}>
                                3
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => handleButtonClick('+')}>
                                +
                            </button>
                        </IonCol>
                        <IonCol size="6" size-md="6" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorGreater} onClick={() => handleButtonClick('0')}>
                                0
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculator} onClick={() => handleButtonClick('.')}>
                                .
                            </button>
                        </IonCol>
                        <IonCol size="3" size-md="3" className={styles.centerContent}>
                            <button className={styles.buttonCalculatorOp} onClick={() => handleButtonClick('=')}>
                                =
                            </button>
                        </IonCol>    
                    </IonRow>
                </IonCard>
                </div>
            </IonContent>
        </IonModal>
    );
}

export default Calculator;